export const CONTRACTOR_JOB_STATUS = {
  HOLDING: 'PENDING',
  HOLD_MEMO: 'HOLD_MEMO',
  DEAL_MEMO: 'DEAL_MEMO',
  ACTIVE: 'ACCEPTED',
  COMPLETED: 'COMPLETED',
  DECLINED: 'DECLINED'
};
